<style scoped lang="less">
.menu-container{
  .layout-logo-left{
    width: 90%;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    margin: 15px auto;
    img{
      width: 30px;
      height: 30px;
      float: left;
    };
    span{
      color: white;
      font-size: 20px;
      font-weight: bolder;
      line-height: 30px;
      float: left;
      text-indent: 10px;
      letter-spacing: 1px;
    }
  }

  .dropdown-container{
    width: 60px;
    color: #f5f5f5;
    text-align: center;
    .dropdown-menu{
      text-align: left;
    }
    .dropdown-btn{
      margin: 8px;
      border: 0;
      color: rgba(255,255,255,.7);
      &:hover{
        color: #fff;
      }
    }
  }
}
</style>

<template>
  <div class="menu-container">
    <Menu theme="dark" width="auto" :active-name="$route.name" accordion
     :open-names="openedSubmenuArr" @on-select="changeMenu" @on-open-change="changeSubmenu" v-show="!shrink" style="overflow:auto">
      <div class="layout-logo-left" >
        <img src="../../assets/images/logo.png">
        <span>运营管理后台</span>
      </div>

      <MenuItem name="notice">
        <Icon type="android-volume-down"></Icon>
        <span class="layout-text">通知</span>
      </MenuItem>

      <Submenu name="materialManage">
        <template slot="title">
          <Icon type="images"></Icon>
          <span class="layout-text">素材管理</span>
        </template>
        <MenuItem name="weChatMaterial">
          <span class="layout-text">微信文章</span>
        </MenuItem>
        <MenuItem name="productManager">
          <span class="layout-text">官网产品</span>
        </MenuItem>
        <MenuItem name="newsManager">
          <span class="layout-text">官网新闻</span>
        </MenuItem>
        <MenuItem name="otherMaterial">
          <span class="layout-text">其他</span>
        </MenuItem>
      </Submenu>

      <Submenu name="appManage">
        <template slot="title">
          <Icon type="android-apps"></Icon>
          <span class="layout-text">APP管理</span>
        </template>
        <MenuItem name="webAPP">
          <span class="layout-text">官网展示</span>
        </MenuItem>
      </Submenu>

      <Submenu name="messageManage">
        <template slot="title">
          <Icon type="android-volume-down"></Icon>
          <span class="layout-text">消息管理</span>
        </template>
        <MenuItem name="templateMessage">
          <span class="layout-text">模板消息推送</span>
        </MenuItem>
        <MenuItem name="helpMessage">
          <span class="layout-text">盲人求助消息</span>
        </MenuItem>
        <MenuItem name="usersMessage">
          <span class="layout-text">用户反馈消息</span>
        </MenuItem>
        <MenuItem name="weChatMessage">
          <span class="layout-text">微信公共账号消息</span>
        </MenuItem>
      </Submenu>

      <Submenu name="usersManage">
        <template slot="title">
          <Icon type="ios-contact"></Icon>
          <span class="layout-text">用户管理</span>
        </template>
        <MenuItem name="blindUsers">
          <span class="layout-text">盲人用户</span>
        </MenuItem>
        <MenuItem name="volunteerUsers">
          <span class="layout-text">志愿者用户</span>
        </MenuItem>
      </Submenu>

      <Submenu name="count">
        <template slot="title">
          <Icon type="ios-pie"></Icon>
          <span class="layout-text">统计</span>
        </template>
        <MenuItem name="totalCount">
          <span class="layout-text">总体数据</span>
        </MenuItem>
        <MenuItem name="appCount">
          <span class="layout-text">APP数据</span>
        </MenuItem>
        <MenuItem name="volunteerCount">
          <span class="layout-text">志愿者数据</span>
        </MenuItem>
      </Submenu>

      <Submenu name="setup">
        <template slot="title">
          <Icon type="gear-b"></Icon>
          <span class="layout-text">设置</span>
        </template>
        <MenuItem name="publicSetting">
          <span class="layout-text">公众号设置</span>
        </MenuItem>
        <!--<MenuItem name="weChatCertificationTab">
          <span class="layout-text">微信认证</span>
        </MenuItem>
        <MenuItem name="safeCenterTab">
          <span class="layout-text">安全中心</span>
        </MenuItem>
        <MenuItem name="violationRecordTab">
          <span class="layout-text">违规记录</span>
        </MenuItem>-->
      </Submenu>

    </Menu>

    <div class="dropdown-container" active-name="" v-show="shrink">
      <div class="layout-logo-left" style="text-align: center">
        <img src="../../assets/images/logo.png" style="float: none">
      </div>

      <Dropdown placement="right-start" name="notice">
        <Button type="text" class="dropdown-btn" @click="changeMenu('notice')">
          <Icon type="android-volume-down" size="20"></Icon>
        </Button>
      </Dropdown>

      <Dropdown placement="right-start" name="materialManage" transfer @on-click="changeMenu">
        <Button type="text" class="dropdown-btn">
          <Icon type="images" size="20"></Icon>
        </Button>

        <DropdownMenu class="dropdown-menu" slot="list">
          <DropdownItem name="weChatMaterial">
            <span class="layout-text">微信文章</span>
          </DropdownItem>
          <DropdownItem name="productManager">
            <span class="layout-text">官网产品</span>
          </DropdownItem>
          <DropdownItem name="newsManager">
            <span class="layout-text">官网新闻</span>
          </DropdownItem>
          <DropdownItem name="otherMaterial">
            <span class="layout-text">其他</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Dropdown placement="right-start" name="appManage" transfer @on-click="changeMenu">
        <Button type="text" class="dropdown-btn">
          <Icon type="android-apps" size="20"></Icon>
        </Button>

        <DropdownMenu class="dropdown-menu" slot="list">
          <DropdownItem name="webAPP">
            <span class="layout-text">官网展示</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Dropdown placement="right-start" name="messageManage" transfer @on-click="changeMenu">
        <Button type="text" class="dropdown-btn">
          <Icon type="android-volume-down" size="20"></Icon>
        </Button>

        <DropdownMenu class="dropdown-menu" slot="list">
          <DropdownItem name="templateMessage">
            <span class="layout-text">模板消息推送</span>
          </DropdownItem>
          <DropdownItem name="helpMessage">
            <span class="layout-text">盲人求助消息</span>
          </DropdownItem>
          <DropdownItem name="usersMessage">
            <span class="layout-text">用户反馈消息</span>
          </DropdownItem>
          <DropdownItem name="weChatMessage">
            <span class="layout-text">微信公共账号消息</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Dropdown placement="right-start" name="usersManage" transfer @on-click="changeMenu">
        <Button type="text" class="dropdown-btn">
          <Icon type="ios-contact" size="20"></Icon>
        </Button>

        <DropdownMenu class="dropdown-menu" slot="list">
          <DropdownItem name="blindUsers">
            <span class="layout-text">盲人用户</span>
          </DropdownItem>
          <DropdownItem name="volunteerUsers">
            <span class="layout-text">志愿者用户</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Dropdown placement="right-start" name="count" transfer @on-click="changeMenu">
        <Button type="text" class="dropdown-btn" @click="changeMenu('AdminHome')">
          <Icon type="ios-pie" size="20"></Icon>
        </Button>

        <DropdownMenu class="dropdown-menu" slot="list">
          <DropdownItem name="totalCount">
            <span class="layout-text">总体数据</span>
          </DropdownItem>
          <DropdownItem name="appCount">
            <span class="layout-text">APP数据</span>
          </DropdownItem>
          <DropdownItem name="volunteerCount">
            <span class="layout-text">志愿者数据</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Dropdown placement="right-start" name="setup" transfer @on-click="changeMenu">
        <Button type="text" class="dropdown-btn">
          <Icon type="gear-b" size="20"></Icon>
        </Button>
        <DropdownMenu class="dropdown-menu" slot="list">
          <DropdownItem name="publicSetting">
            <span class="layout-text">公众号设置</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import mixin from "../../utils/mixin";
import { adminRouter } from "../../router/admin";
import Utils from '../../utils/util.js';

export default {
  name: "menuLists",
  mixins: [mixin], // 用来更高效的实现组件内容的复用
  props: ["shrink"],
  data(){
    return {

    };
  },
  methods: {
    changeMenu (active){ //active就是当前页面的名字
      if(this.currentTag !== active){
        let tags = null;
        for(let ele of adminRouter){
          if(ele.name===active){
            tags = {
              title: ele.title,
              name: ele.name,
              path: ele.path
            };
            break;
          }else{
            if(ele.children.length){
              for(let val of ele.children){
                if(val.name === active){
                  tags = {
                    title: val.title,
                    name: val.name,
                    path: val.path
                  };
                  break;
                }
              }
            }
          }
        }
        localStorage.setItem("currentTag", active);
        this.$store.commit("updateCurrentTag", active);
        this.$store.commit("updateOpenedTags", [tags]);
        this.$store.commit("updateCurrentPath", active);
        this.$router.push({
          name: active
        });
      }
    },
    changeSubmenu(arr){
      this.$store.commit("openedSubmenu", arr);
      localStorage.setItem("openedSubmenu", JSON.stringify(arr));
    }
  },
  mounted(){
    var that = this;
    Utils.$on('demo', function (msg) {
      // console.log(msg);
      that.changeMenu(msg);
    });
  },
  created (){

  }
};
</script>



// WEBPACK FOOTER //
// menu-lists.vue?d9454102